import { AccountTypeDetails, CaymanAccountTypeName } from '@/types/api/account';

export const isCaymanAccountEligible = (
  accountType: AccountTypeDetails,
  age: number,
) => {
  const name = accountType.name as CaymanAccountTypeName;

  if (!age || age < 18) {
    return false;
  }
  if (
    age >= 18 &&
    age < 22 &&
    [CaymanAccountTypeName.GenNow, CaymanAccountTypeName.Chequing].includes(
      name,
    )
  ) {
    return true;
  }
  if (
    age >= 22 &&
    age < 60 &&
    [CaymanAccountTypeName.EZBanking, CaymanAccountTypeName.Chequing].includes(
      name,
    )
  ) {
    return true;
  }
  if (
    age >= 60 &&
    [CaymanAccountTypeName.Caymanite, CaymanAccountTypeName.Chequing].includes(
      name,
    )
  ) {
    return true;
  }

  return false;
};

export function sortBankAccountsByProductAndCurrency<
  T extends { name?: string | null; currency?: string | null },
>(accounts: T[]): T[] {
  return [...accounts].sort(
    (a, b) =>
      (a.name ?? '').localeCompare(b.name ?? '') ||
      (a.currency ?? '').localeCompare(b.currency ?? ''),
  );
}
